<!-- Bühne wie in orbi-animation-lab/index.html: hintere Speed Lines, hinteres
     Loch, Orbi, vordere Speed Lines, Boden, vorderes Loch (Loch/Boden nur für
     `hide-surprise`); die Effekt-Ebene (Noten, Gedankenblase, Konfetti)
     hängt die Komponente hinter den Mount. `stage` ist die Klasse, über die
     der Lab-Controller seine Szene findet (`root.closest(".stage")`). -->
<div class="orbi-lab-stage stage" [style.transform]="stageTransform" [attr.aria-hidden]="playStop ? null : 'true'">
  <svg class="stage-speed-lines stage-speed-lines--back" id="spin-speed-lines-back" viewBox="0 0 420 300" aria-hidden="true">
    <defs>
      <linearGradient [attr.id]="speedBackId" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stop-color="#7658ea" stop-opacity=".04" />
        <stop offset=".42" stop-color="#8166ef" stop-opacity=".7" />
        <stop offset="1" stop-color="#5140bb" stop-opacity=".08" />
      </linearGradient>
    </defs>
    <g [attr.stroke]="'url(#' + speedBackId + ')'">
      <path class="stage-speed-line stage-speed-line--long" d="M49 99C128 62 292 62 371 99" />
      <path class="stage-speed-line stage-speed-line--medium" d="M24 123C113 86 307 86 396 123" />
      <path class="stage-speed-line stage-speed-line--fast" d="M7 148C108 110 312 110 413 148" />
      <path class="stage-speed-line stage-speed-line--medium" d="M22 172C113 138 307 138 398 172" />
    </g>
  </svg>

  <div class="orbi-hole orbi-hole--back" id="orbi-hole-back"></div>
  <div class="orbi-lab-mount" #mount></div>

  <svg class="stage-speed-lines stage-speed-lines--front" id="spin-speed-lines-front" viewBox="0 0 420 300" aria-hidden="true">
    <defs>
      <linearGradient [attr.id]="speedFrontId" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stop-color="#9a86ff" stop-opacity=".04" />
        <stop offset=".5" stop-color="#6f4af8" stop-opacity=".96" />
        <stop offset="1" stop-color="#4f3cc6" stop-opacity=".06" />
      </linearGradient>
    </defs>
    <g [attr.stroke]="'url(#' + speedFrontId + ')'">
      <path class="stage-speed-line stage-speed-line--fast" d="M6 149C108 191 312 191 414 149" />
      <path class="stage-speed-line stage-speed-line--long" d="M21 174C113 215 307 215 399 174" />
      <path class="stage-speed-line stage-speed-line--medium" d="M47 199C130 237 290 237 373 199" />
      <path class="stage-speed-line stage-speed-line--short" d="M79 219C147 247 273 247 341 219" />
    </g>
  </svg>
  <div class="stage-ground-cover" id="stage-ground-cover"></div>
  <div class="orbi-hole orbi-hole--front" id="orbi-hole-front"></div>
</div>
